import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  changeSortOfClinicList,
  changeSortOfClinicianPatientsList,
  loadMoreClinicianPatients,
  loadMoreClinicians,
} from "store/ClinicianStore/actions";
import {
  selectCurrentClinician,
  selectClinicHasMoreClinicians,
  selectSortConfig,
  selectClinicianHasMorePatients,
  selectSortConfigClinicianPatients,
  selectCurrentClinicianLoading,
  selectCurrentClinicianPatientsLoading,
} from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { ManagementType } from "types/common";
import { ContainerForCliniciansOtherRoles } from "./ContainerForCliniciansOtherRoles";
import {
  selectClinicHasMoreClinicPatients,
  selectLoading,
  selectSortConfigClinicPatients,
} from "store/PatientStore/selectors";
import {
  changeSortOfClinicPatientsList,
  loadMoreClinicPatients,
} from "store/PatientStore/actions";
import { Clinician } from "types/Clinician";
import {
  setClinicianPatientsList,
  setCliniciansList,
} from "store/ClinicianStore/clinicianSlice";
import { setClinicPatientsList } from "store/PatientStore/patientSlice";

type Props = {
  managementType?: ManagementType;
};

export const UserListContaier = ({ managementType }: Props) => {
  const dispatch = useAppDispatch();
  const currentClinician: Clinician | undefined = useAppSelector(
    selectCurrentClinician
  );
  const hasMoreItems = useAppSelector(selectClinicHasMoreClinicians);
  const hasMorePatients = useAppSelector(selectClinicHasMoreClinicPatients);
  const hasMoreClinicianPatients = useAppSelector(
    selectClinicianHasMorePatients
  );
  const sortConfig = useAppSelector(selectSortConfig);
  const sortConfigClinicianPatients = useAppSelector(
    selectSortConfigClinicianPatients
  );
  const sortConfigClinicPatients = useAppSelector(
    selectSortConfigClinicPatients
  );
  const clinicianPatientsLoading = useAppSelector(
    selectCurrentClinicianLoading
  );
  const clinicianPatientsIsLoading = useAppSelector(
    selectCurrentClinicianPatientsLoading
  );
  const clinicPatientsLoading = useAppSelector(selectLoading);

  const onLoadMore = useCallback(
    (page) => {
      dispatch(loadMoreClinicians(page));
    },
    [dispatch]
  );

  const onLoadMoreClinicPatients = useCallback(() => {
    dispatch(loadMoreClinicPatients());
  }, [dispatch]);

  const onLoadMoreClinicianPatients = useCallback(() => {
    if (currentClinician) {
      dispatch(loadMoreClinicianPatients(currentClinician._id ?? ""));
    }
  }, [currentClinician]);

  const onClick = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(changeSortOfClinicList(sortBy));
      setCliniciansList([]);
    }
  };

  const onClickClinicianPatients = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(
        changeSortOfClinicianPatientsList(sortBy, currentClinician?._id ?? "")
      );
      setClinicianPatientsList([]);
    }
  };

  const onClickClinicPatients = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(changeSortOfClinicPatientsList(sortBy));
      setClinicPatientsList([]);
    }
  };

  const getSortConfig = () => {
    if (managementType === ManagementType.PATIENT_CARE) {
      return sortConfigClinicianPatients;
    } else if (managementType === ManagementType.PATIENT) {
      return sortConfigClinicPatients;
    } else {
      return sortConfig;
    }
  };

  return (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      {(currentClinician?.role?.includes(USER_GROUPS.CLINIC_ADMIN) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_MEMBER)) && (
        <ContainerForCliniciansOtherRoles
          managementType={managementType}
          currentClinician={currentClinician}
          hasMorePatients={hasMorePatients}
          sortConfig={getSortConfig()}
          onLoadMore={onLoadMore}
          onLoadMorePatients={onLoadMoreClinicPatients}
          onLoadMoreClinicianPatients={onLoadMoreClinicianPatients}
          hasMoreClinicianPatients={hasMoreClinicianPatients}
          onClick={onClick}
          clinicianPatientsLoading={
            clinicianPatientsLoading || clinicianPatientsIsLoading
          }
          clinicPatientsLoading={clinicPatientsLoading}
          onClickClinicianPatients={onClickClinicianPatients}
          onClickClinicPatients={onClickClinicPatients}
        />
      )}
    </div>
  );
};
